import Vue from 'vue'
import VueRouter from 'vue-router'
// 路由模块
import {inquiryRouter, InquiryQrcodeRouter} from './modules/inquiry'
import newsRouter from './modules/news'
import qrcodeRouter from './modules/qrcode'
import joinsRouter from './modules/joins'
import aboutRouter from './modules/about'
import homeRouter from './modules/home'
import productRouter from './modules/product'
import {getWebsiteConfig, setWebsiteConfig} from "@/utils/website-config";
import request from "@/utils/request";
import {getCity, setCity} from "@/utils/locate";

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [inquiryRouter, InquiryQrcodeRouter, newsRouter, qrcodeRouter, joinsRouter, aboutRouter, homeRouter, productRouter, {
    path: '/:path(.*)*',
    component: () => import('@/views/exception/404/index.vue')
}]

const router = new VueRouter({
    routes,
    mode: 'history',
    path: '/',
    scrollBehavior: (to, from, savedPosition) => {
        if (to.hash) {
            return {selector: to.hash}
        }
        return {y: 0}
    }
})

router.beforeEach((to, from, next) => {
    if (!getWebsiteConfig()) {
        // 网址配置
        request.get('/Website/config')
            .then(res => {
                if (res.code === 0) {
                    setWebsiteConfig(res.data)
                }
                if (!getCity()) {
                    request.get('/website/city')
                        .then(res => {
                            if (res.code === 0) {
                                setCity(res.data)
                            }
                            next()
                        })
                        .catch(() => {
                            next()
                        })
                } else {
                    next()
                }
            }).catch(() => {
            next()
        })
    } else {
        next()
    }
})

export default router